import { faFilePdf, faPlus, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Box } from '../../flayr-components/Box/Box';
import { Flex } from '../../flayr-components/Flex/Flex';
import { Img } from '../../flayr-components/Img/Img';
import { ShowIf } from '../../flayr-components/ShowIf/ShowIf';
import ArrayMap from '../ArrayMap/ArrayMap';
import ImgUploader from '../ImgUploader/ImgUploader';

interface IPicWallProps {
  title?: string;
  subTitle?: string;
  className?: string;
  images?: string[];
  name?: string;
  onUpload?: (e?: any) => void;
  onDelete?: (e?: any) => void;
  accept?: string;
  profileId?: string;
}

const PicWall: React.FC<React.PropsWithChildren<IPicWallProps>> = ({
  onUpload,
  images,
  title,
  subTitle,
  name,
  className,
  onDelete,
  profileId,
  accept,
}) => {
  return (
    <div className={className}>
      <div className="font-medium">{title}</div>
      <ShowIf condition={subTitle}>
        <div className="mb-3 text-sm text-gray-600">{subTitle}</div>
      </ShowIf>
      <Flex className="w-full pt-4 overflow-x-auto" wrap={false}>
        <div className="flex-none w-24 mr-2">
          <ImgUploader
            previewUploadingImg
            previewClassName="w-full"
            onUpload={onUpload}
            enableBuiltInImgUpload
            name={name}
            id={profileId}
            accept={accept}
          >
            <Box
              icon={
                <FontAwesomeIcon
                  icon={faPlus}
                  className="w-full text-xl leading-tight text-gray-500"
                />
              }
              className="flex-wrap border border-gray-300 border-dashed cursor-pointer"
              bg="gray-100"
            >
              <div className="w-full -mt-6 text-sm leading-tight text-gray-500">
                Upload
              </div>
            </Box>
          </ImgUploader>
        </div>

        <ArrayMap
          items={images || []}
          render={(img, idx) => (
            <div className="relative flex-none w-24 mr-2">
              {img.includes('.pdf') && (
                <Box
                  icon={
                    <FontAwesomeIcon
                      icon={faFilePdf}
                      className="text-5xl text-red-400"
                    />
                  }
                />
              )}

              {!img.includes('.pdf') && (
                <Img src={img} size="square" roundedCorners />
              )}
              <div className="absolute top-0 right-0 transform translate-x-1 -translate-y-1">
                <button
                  className="flex items-center justify-center w-5 h-5 text-white bg-red-500 rounded-full shadow-sm focus:outline-none cursor:pointer"
                  id={idx}
                  onClick={onDelete}
                >
                  <FontAwesomeIcon
                    icon={faTimes}
                    className="text-sm leading-none pointer-events-none"
                  />
                </button>
              </div>
            </div>
          )}
        />
        <div className="w-px" />
      </Flex>
    </div>
  );
};
export default PicWall;
